// Resolves the {value, label} choices a dropdown/radio_group field should
// render to the candidate.
//
// `bullhorn_picklist_options` is only trustworthy when the field is
// genuinely Bullhorn-backed (`bullhorn_picklist_entity_backed` — fetched
// live from Bullhorn's own field metadata, where value/label can legitimately
// differ, e.g. a picklist ID vs its display name). For a plain
// recruiter-authored option list, `bullhorn_picklist_options` is at best a
// one-time mirror auto-populated when the field was first mapped (see
// TemplateEditorPage's field-options sync effect) — it is never touched
// again when the recruiter later edits `options` by hand, so it silently
// goes stale. Preferring it whenever merely non-empty let an edited radio
// group keep showing its old option text to candidates indefinitely.
export function resolvePicklistPairs(field) {
  const hasSyncedPicklist = !!field?.bullhorn_picklist_entity_backed
    && Array.isArray(field?.bullhorn_picklist_options)
    && field.bullhorn_picklist_options.length > 0;
  if (hasSyncedPicklist) return field.bullhorn_picklist_options;
  return (field?.options || []).map((opt) => ({ value: opt, label: opt }));
}
